const STATES: { [abbreviation: string]: string } = {
  USA: 'US Congress',
  AL: 'Alabama',
  AK: 'Alaska',
  AS: 'American Samoa',
  AZ: 'Arizona',
  AR: 'Arkansas',
  CA: 'California',
  CO: 'Colorado',
  CT: 'Connecticut',
  DE: 'Delaware',
  DC: 'District Of Columbia',
  FM: 'Federated States Of Micronesia',
  FL: 'Florida',
  GA: 'Georgia',
  GU: 'Guam',
  HI: 'Hawaii',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  IA: 'Iowa',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  ME: 'Maine',
  MH: 'Marshall Islands',
  MD: 'Maryland',
  MA: 'Massachusetts',
  MI: 'Michigan',
  MN: 'Minnesota',
  MS: 'Mississippi',
  MO: 'Missouri',
  MT: 'Montana',
  NE: 'Nebraska',
  NV: 'Nevada',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NY: 'New York',
  NC: 'North Carolina',
  ND: 'North Dakota',
  MP: 'Northern Mariana Islands',
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  PW: 'Palau',
  PA: 'Pennsylvania',
  PR: 'Puerto Rico',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UT: 'Utah',
  VT: 'Vermont',
  VI: 'Virgin Islands',
  VA: 'Virginia',
  WA: 'Washington',
  WV: 'West Virginia',
  WI: 'Wisconsin',
  WY: 'Wyoming',
};

export default STATES;

// Gradient steps generated using https://colordesigner.io/gradient-generator
export const MAP_COLORS: { [key: string]: string } = {
  grey: '#eaeaea',
  blue_1: '#b4e2f1',
  blue_2: '#aadcec',
  blue_3: '#a1d5e8',
  blue_4: '#97cfe3',
  blue_5: '#8ec9df',
  blue_6: '#84c3da',
  blue_7: '#7abdd6',
  blue_8: '#70b7d1',
  blue_9: '#66b0cd',
  blue_10: '#5caac9',
  blue_11: '#51a4c5',
  blue_12: '#459ec0',
  blue_13: '#3798bc',
  blue_14: '#2892b8',
  blue_15: '#0f8cb4',
};

export function getStateFillColor(count: number, maxCount: number): string {
  if (count === 0) return MAP_COLORS.blue_1;
  const fillFactor = Math.ceil((count / maxCount) * 14) + 1;
  return MAP_COLORS[`blue_${fillFactor}`];
}
